import * as React from 'react'
import { Col, Flex, Row, Typography } from 'antd'
import ExpandedText from '../text-elipsis'
import Certificate from '../../shared/types'
import { useStore } from 'effector-react'
import { paymentStore } from '../../shared/state'
import { StyledParagraph } from '../../shared/ui'
import { useEffect } from 'react'
import { getNewHref } from '../../shared/lib'
const { Paragraph } = Typography

interface Props {
    certificate: Certificate | null
}
export default function MainPagePayCertificate({ certificate }: Props) {
    if (certificate == null) {
        return <></>
    }
    if (certificate.email_title == '') {
        certificate.email_title = 'Email'
    }

    const paymentInfo = useStore(paymentStore)

    const renderPaymentWidget = (confirmation_token: string) => {
        // @ts-ignore
        const checkout = new window.YooMoneyCheckoutWidget({
            confirmation_token: confirmation_token, //Токен, который перед проведением оплаты нужно получить от ЮKassa
            return_url: getNewHref('isPayed', 'true'), //Ссылка на страницу завершения оплаты, это может быть любая ваша страница

            //При необходимости можно изменить цвета виджета, подробные настройки см. в документации
            //customization: {
            //Настройка цветовой схемы, минимум один параметр, значения цветов в HEX
            //colors: {
            //Цвет акцентных элементов: кнопка Заплатить, выбранные переключатели, опции и текстовые поля
            //control_primary: '#00BF96', //Значение цвета в HEX

            //Цвет платежной формы и ее элементов
            //background: '#F2F3F5' //Значение цвета в HEX
            //}
            //},

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            error_callback: function (error: any) {
                // console.log(error)
            },
        })

        //Отображение платежной формы в контейнере
        checkout.render('payment-form')
    }
    useEffect(() => {
        renderPaymentWidget(paymentInfo.confirmation_token)
    }, [])
    return (
        <div style={{ width: '100%' }}>
            <Row justify="center" align={'stretch'} style={{ height: '100%' }} className="gi-gray-color">
                <Col xs={{ span: 0 }} flex={'auto'}></Col>
                <Col
                    xl={{ span: 8 }}
                    xxl={{ span: 8 }}
                    lg={{ span: 8 }}
                    md={{ span: 10 }}
                    sm={{ span: 14 }}
                    xs={{ span: 24 }}
                >
                    <div className="gi-header-text text-justify">{certificate.order_detail}</div>
                    <div>
                        <Flex justify={'center'} align={'center'}>
                            <div
                                className="gi-card gi-card-back card-size"
                                style={{
                                    backgroundImage: `url('${certificate.logo}')`,
                                }}
                            ></div>
                        </Flex>
                    </div>
                </Col>
                <Col xs={{ span: 0 }} flex={'auto'}></Col>
            </Row>
            <Paragraph></Paragraph>
            <Row justify="center" style={{ backgroundColor: 'white' }}>
                <Col flex={'auto'}></Col>
                <Col
                    style={{ paddingLeft: '5px', paddingRight: '5px' }}
                    xl={{ span: 8 }}
                    xxl={{ span: 8 }}
                    lg={{ span: 8 }}
                    md={{ span: 10 }}
                    sm={{ span: 14 }}
                    xs={{ span: 24 }}
                >
                    <Paragraph style={{ marginBottom: '0.6em' }}>
                        <b>{certificate.issuer_title}: </b> {certificate.issuer_name}
                    </Paragraph>

                    <ExpandedText
                        title={certificate.order_sum}
                        text={paymentInfo.price + ' ' + certificate.currency_symbol}
                    />
                    <StyledParagraph title={certificate.email_title} value={paymentInfo.email} />
                </Col>
                <Col flex={'auto'}></Col>
            </Row>
            <div id="payment-form"></div>
        </div>
    )
}
